'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _targetdrgs = require('./targetdrgs.html');

var _targetdrgs2 = _interopRequireDefault(_targetdrgs);

var _targetdrgs3 = require('./targetdrgs.controller');

var _targetdrgs4 = _interopRequireDefault(_targetdrgs3);

require('./targetdrgs.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var targetdrgsComponent = {
  restrict: 'E',
  bindings: {},
  template: _targetdrgs2.default,
  controller: _targetdrgs4.default,
  controllerAs: 'vm'
};

exports.default = targetdrgsComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/targetdrgs/targetdrgs.component.js